<template>
  <div class="home-page">
    <Menu-component/>
    <div class="container">
      <div class="wrapper">
          <div class="box-01">
            <h1>
              Segurança Hídrica: do conceito à aplicação prática no planejamento da infraestrutura hídrica estratégica do Brasil.
            </h1>
            <router-link tag="a" to="saibamais" class="saiba-mais">Saiba mais ></router-link>
            <p>A garantia da segurança hídrica para o desenvolvimento sustentável do Brasil é a missão institucional da Agência Nacional de Águas (ANA) e uma das principais atribuições do Ministério do Desenvolvimento Regional (MDR).</p>
          </div>
          <div class="box-02">
            <h2>O PNSH oferece o Caminho da <br> Segurança Hídrica no Brasil</h2>
            <p>Realizado de forma pioneira e inovadora, a partir de diretrizes e critérios advindos do conceito de Segurança Hídrica, o PNSH assegura ao Brasil um planejamento integrado e consistente de infraestrutura hídrica, com natureza estratégica e relevância regional, com base nos principais problemas de segurança hídrica do país.</p>
            <p>O PNSH, assim, se soma ao planejamento da gestão de recursos hídricos e preenche o rol de instrumentos necessários ao alcance de objetivos da Política Nacional de Recursos Hídricos, que estabelece a necessidade de assegurar à atual e às futuras gerações a adequada disponibilidade de água e de atuar na prevenção contra eventos hidrológicos críticos.</p>
          </div>
      </div>
      <div class="video-play">
        <span id="video-button" @click="toggleMenu"></span>
        <p  @click="toggleMenu">Confira o vídeo <br> do PNSH</p>
      </div>
      <div class="wrapper-marcas">
        <div class="logo-maras">
          <ul>
            <li style="margin-right: 5px">
              <a href="http://www3.ana.gov.br/">
                <img src="@/assets/logo-ana-2.png" alt="Logo Ana">
              </a>
            </li>
            <li>
              <a href="http://www.mi.gov.br/desenvolvimento-regional">
                <img src="@/assets/logo-assinatura-ministerio.png" alt="Logo Ministrerio Desenvolvimento">
              </a>
            </li>
            <li>
              <a href="http://www.brasil.gov.br/">
                <img src="@/assets/logo-assinatura-brasil.png" alt="Logo Ministrerio Desenvolvimento">
              </a>
            </li>
          </ul>
        </div>
        <router-link tag="button" class="btn-green" to="seguranca">O Índice de Seguranca Hídrica</router-link>

      </div>
    </div>
    <Modal-video/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Menu from '@/components/Menu'
import Modal from '@/components/ModalVideo'


export default {
  name: 'home',

  components: {
    'Menu-component': Menu,
    'Modal-video': Modal
  },

  computed: {
    ...mapState({
      statusModal: (state) => state.Layout.modal,
      statusModalVideo: (state) => state.Layout.modalVideo
    })
  },

  data () {
    return {
        modal: false
    };
  },

  methods: {
      ...mapActions({
          setSetorAtivo: 'Layout/setSetorAtivo',
          mostrarVideo: 'Layout/mostrarModalVideo'
      }),
      toggleMenu () {
          this.mostrarVideo(true)
      }
  }
};
</script>



<style lang="scss" scoped>

.container {
    padding-top: get-vh(140px);
    width: 1235px;
    display: block;
    margin: 0 auto;
    @include media_tablet() {
        padding-top: 50px;
        width: 100%;
    }
}

.home-page {
    background-image: linear-gradient(65deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.9)),url(../assets/splash.png);
    height: 100vh;
    width: 100vw;
    max-width: 100%;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;

    .wrapper {
      display: flex;

      @include media_tablet() {
        display: flex;
        padding: 0 20px;
      }

      .box-01 {

        position: relative;
        padding-right: 2vw;
        width: 49%;

        &::before {
            content: '';
            background: #564f4f;
            position: absolute;
            right: 0px;
            height: 100%;
            animation: borderHeight 0.6s linear;
            width: 1px;
             @include media_tablet() {
                background: none;
            }
        }

        @keyframes borderHeight {
            0%   { height: 0%; }
            100% { height: 100%; }
        }

        @include media_tablet() {
          border: none;
          width: 100%;
        }

        h1 {
          color: #8fc74a;
          font-family: 'rubik_medium';
          font-size: 37px;
          font-weight: 500;
          line-height: 44px;
          margin-bottom: get-vh(15px);
          width: 80%;

          @media (max-height:  900px) and (min-width: 1200px) {
            font-size: 24px;
            line-height: 30px;
            width: 400px;
          }

          @include media_tablet() {
            color: #ffffff;
            font-size: 25px;
            line-height: normal;
          }

          @include media_mobile_small() {
              font-size: 20px;
          }

        }

        p {
            color: #ffffff;
            font-size: 14px;
            line-height: 26px;
            padding-right: 5vw;

            @media (max-height:  900px) and (min-width: 1200px) {
              line-height: 22px;
            }

            @include media_tablet() {
              display: none;
            }
        }

        .saiba-mais {
          display: none;
          @include media_tablet() {
            display: block;
            color:#8fc74a;
            font-size: 16px;
            font-weight: bold;
            font-family: 'rubik_bold';
            margin-bottom: 15px;
          }
         @include media_mobile_small() {
            font-size: 14px;
          }
        }

      }

      .box-02 {
        padding-left: 90px;
        width: 51%;

        @include media_tablet() {
          display: none;
        }

        h2 {
          color: #3994d0;
          font-size: 22px;
          margin-bottom: get-vh(19px);

          @media (max-height:  900px) and (min-width: 1200px) {
            font-size: 18px;
          }
        }

        p {
            color: #ffffff;
            font-size: 14px;
            line-height: 26px;
            padding-right: 5vw;
            margin-top: get-vh(20px);

            @media (max-height:  900px) and (min-width: 1200px) {
              font-size: 13px;
              line-height: 22px;
            }
        }

      }
    }

    .video-play {
      cursor: pointer;
      display: flex;
      align-items: center;
      width: 100%;

      @include media_tablet() {
        padding: 0 23px;
      }

      p {
        color: #ffffff;
        line-height: 22px;
        cursor: pointer;

        @include media_tablet() {
          line-height: 18px;
        }
      }

      #video-button {
        background-image: url(../assets/play.png);
        background-repeat: no-repeat;
        background-size: 80%;
        background-position: center center;
        margin-right: 15px;
        height: 65px;
        width: 65px;
      }

    }


    .wrapper-marcas {
      display: flex;
      justify-content: space-between;
      align-items: center;

      @include media_tablet() {
        flex-direction: column;
      }

      ul {
        display: flex;
        height: 54px;
        margin-top: 30px;

        @media (max-height:  900px) and (min-width: 1200px) {
          margin: 10px 0 0 0;
        }

        li {
          img {
            height: 54px;
          @include media_tablet() {
              height: 40px;
              object-fit: contain;
           }
          }
        }
      }
      button {
          cursor: pointer;
          &::after {
            content: "";
            position: absolute;
            right: 10px;
            top: 17px;
            background-repeat: no-repeat;
            background-image: url(../assets/seta-direita-branca.svg);
            width: 9px;
            height: 14px;
            @include media_tablet() {
                right: 35px;
             }
          }

          @include media_tablet() {
            position: absolute;
            bottom: 0px;
            width: 100%;
            border-radius: 30px 30px 0 0;
          }
        }
    }
}
</style>
